import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { FILTER_FONT_SIZE } from "../common/filterBarStyles";
import { navigateToRemediationHub } from "../common/remediationHubNavigation";

const NEXT_STEPS = [
  "CloudCatcher validates permissions and builds a dry-run preview.",
  "You'll be notified when the request is ready to approve.",
  "Review the plan in Remediation Hub, approve it, and the fix runs on your schedule.",
];

const FileRequestFollowUpDialog = ({ open, variant, requestIds = [], onClose }) => {
  const primaryId = requestIds.length === 1 ? requestIds[0] : null;
  const isDedup = variant === "dedup";

  const title = isDedup
    ? "Existing request found"
    : requestIds.length > 1
      ? "Remediation requests filed"
      : "Remediation request filed";

  const intro = isDedup
    ? primaryId
      ? `No new request was created. An active remediation request already exists for this check and resource (Request #${primaryId}). Open that request in Remediation Hub to review its status, approve the dry-run plan when ready, and track execution.`
      : "No new request was created. An active remediation request already exists for this check and resource. Open Remediation Hub to find and manage the existing request."
    : primaryId
      ? `Request #${primaryId} has been filed successfully.`
      : `${requestIds.length} remediation requests have been filed successfully.`;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 2 } }}>
      <DialogTitle sx={{ fontWeight: 600, pb: 1 }}>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2, fontSize: FILTER_FONT_SIZE, lineHeight: 1.55 }}>
          {intro}
        </Typography>

        <Typography variant="caption" sx={{ fontWeight: 600, display: "block", mb: 1 }}>
          What happens next
        </Typography>
        <List dense disablePadding sx={{ mb: 1 }}>
          {NEXT_STEPS.map((step, i) => (
            <ListItem key={i} disableGutters sx={{ py: 0.35, alignItems: "flex-start" }}>
              <ListItemText
                primary={`${i + 1}. ${step}`}
                primaryTypographyProps={{ fontSize: FILTER_FONT_SIZE, lineHeight: 1.5 }}
              />
            </ListItem>
          ))}
        </List>

        {requestIds.length > 1 && (
          <Box sx={{ mt: 1.5 }}>
            <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.5 }}>
              Request IDs: {requestIds.map((id) => `#${id}`).join(", ")}
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, pt: 0, flexWrap: "wrap", gap: 1 }}>
        <Button onClick={onClose} sx={{ textTransform: "none" }}>
          Close
        </Button>
        <Button
          variant="outlined"
          onClick={() => navigateToRemediationHub()}
          sx={{ textTransform: "none" }}
        >
          Go to Remediation Hub
        </Button>
        {primaryId != null && (
          <Button
            variant="contained"
            endIcon={<OpenInNewIcon />}
            onClick={() => navigateToRemediationHub(primaryId)}
            sx={{ textTransform: "none" }}
          >
            View request #{primaryId}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default FileRequestFollowUpDialog;
